import React, { Component } from 'react';

import Form from "@sm/core/Form";

import { crudActions } from "@sm/services/crudActions";
import { DATA_TYPES } from "@modules/data/ManualInput";

class OtcSettlementByRequestComponent extends Component {
  state = {
    otcSettlementByRequestBaseMidRowFields: [
      {
        name: "provider",
        label: "Provider",
        disabled: true,
        fieldType: "input",
        flexGrow: "0.25"
      }, {
        name: "account",
        label: "Account",
        disabled: true,
        fieldType: "input",
        flexGrow: "0.35"
      }, {
        name: "id",
        label: "MID",
        disabled: true,
        fieldType: "input",
        flexGrow: "0.2"
      }, {
        name: "name",
        label: "Tags",
        disabled: true,
        fieldType: "input",
        flexGrow: "0.5"
      }, {
        name: "payoutWalletBalance",
        label: "Payout Wallet",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: "0.25",
        rightAlign: true,
      },{
        name: "pendingPayouts",
        label: "Pending Payouts",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: "0.25",
        rightAlign: true,
      }, {
        name: "availableBalance",
        label: "Available Balance",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: "0.25",
        rightAlign: true,
      }, {
        name: "collectedFunds",
        label: "Collected Funds",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: "0.25",
        rightAlign: true,
      }, {
        name: "balanceToSettle",
        label: "Balance to Settle",
        disabled: true,
        fieldType: "input",
        formatValue: false,
        flexGrow: "0.25",
        rightAlign: true,
      }, {
        name: "checkBox",
        fieldType: "checkBox",
        autoMethod: (index) => this.props.onMidSelect(index, DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST),
        alignSelf: "end",
        disabled: true,
        flexGrow: "0"
      }
    ],
    otcSettlementByRequestBaseFields: [
      [
        {
          name: "currency",
          label: "MID Currency",
          disabled: true,
          fieldType: "input",
          flexGrow: "2",
        },
        {
          name: "availableBalance",
          label: "Total Available Balance",
          disabled: true,
          fieldType: "input",
          formatValue: true,
          flexGrow: "10",
        },
        {
          name: "requestedSettlement",
          label: "Requested Settlement",
          // onDoubleClick: (index, fieldName, label) => this.onDoubleClick(index, fieldName, label), //for feature improvements
          disabled: true,
          fieldType: "input",
          formatValue: true,
          flexGrow: "10",
        },
        {
          name: "balanceToSettle",
          label: "Balance to Settle",
          disabled: true,
          fieldType: "input",
          formatValue: true,
          flexGrow: "10",
        },
        {
          name: "propertyId",
          label: "Status",
          fieldType: "select",
          getOptions: () => this.getOptionsFromState("statuses"),
          items: "statuses",
          flexGrow: "10",
        },
      ],
      [
        {
          name: "fxPair",
          label: "FX Pair",
          disabled: true,
          fieldType: "input",
          flexGrow: "2",
        },
        {
          name: "fxRate",
          label: "FX Rate",
          disabled: true,
          fieldType: "input",
          formatValue: true,
          flexGrow: "10",
          // onDoubleClick: (index, fieldName, label) => this.onDoubleClick(index, fieldName, label) //for feature improvements
        },
        {
          name: "otcRequestedSettlement",
          label: "OTC Requested Settlement",
          fieldType: "input",
          formatValue: true,
          disabled: true,
          flexGrow: "10",
        },
        {
          name: "settlementFee",
          label: "Settlement Fee",
          disabled: true,
          fieldType: "input",
          formatValue: true,
          flexGrow: "10",
        },
        {
          name: "otcSettlement",
          label: "OTC Settlement",
          disabled: true,
          fieldType: "input",
          formatValue: true,
          flexGrow: "10",
        },
        {
          name: "confirmationLink",
          label: "Confirmation Link",
          fieldType: "input",
          flexGrow: "10",
        },
      ],
      [
        { fieldType: "empty" }, { fieldType: "empty" }, { fieldType: "empty" },
        {
          name: "notes",
          label: "Notes",
          fieldType: "textarea",
          flexGrow: "1",
        },
        { fieldType: "button" },
      ]
    ],
    otcSettlementFormByRequestTotal: new Form(
      {
        collectedFunds: null,
        availableBalance: null,
        requestedSettlement: null,
        balanceToSettle: null,
        propertyId: "",
      },
      [
        {
          name: "propertyId",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "availableBalance",
          type: "isNumber",
          rules: {
            min: 0,
            required: true,
          },
        },
        {
          name: "requestedSettlement",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "balanceToSettle",
          type: "isNumber",
          rules: {
            min: 0,
            required: true,
          },
        },
      ]
    ),
    otcSettlementFormByRequestOtc: new Form(
      {
        invoice: null,
        fxPair: null,
        fxRate: null,
        otcRequestedSettlement: null,
        settlementFee: null,
        otcSettlement: null,
        confirmationLink: null
      },
      [{
        name: "fxPair",
        type: "isString",
        rules: {
          required: true,
        },
      }, {
        name: "fxRate",
        type: "isNumber",
        rules: {
          required: true,
        },
      }, {
        name: "otcRequestedSettlement",
        type: "isNumber",
        rules: {
          required: true,
        },
      }, {
        name: "settlementFee",
        type: "isNumber",
        rules: {
          required: true,
        },
      }, {
        name: "otcSettlement",
        type: "isNumber",
        rules: {
          required: true,
        },
      }, {
        name: "confirmationLink",
        type: "isUrl",
        rules: {
          required: true,
        },
      },]
    )
  };

  componentDidMount() {
    const { statuses } = this.props;
    if (statuses) {
      this.setState({
        statuses: statuses,
      });
    }
  }

  onSaveDataEntries = () => {
    const { form, formTotal, savedData, settlementMids } = this.props;

    const isFormValid = form.map((elem) => elem.isFormValid()).every(Boolean);
    this.saveValidationUpdate(form, isFormValid, isFormValid && formTotal.balanceToSettle > 0);

    const notes = form[form.length - 1].notes;
    const otcTotal = form[form.length - 2];

    if (isFormValid) {
      if (formTotal.balanceToSettle > 0 || formTotal.propertyId === "19") {
        let validSettlements = settlementMids.filter(m => (m.isChecked && m.balanceToSettle > 0 && form.propertyId !== "19") || (m.isChecked && form.propertyId === "19"));
        if (!validSettlements.length) {
          settlementMids[0].balanceToSettle = 0;
          validSettlements = [settlementMids[0]];
          formTotal.balanceToSettle = 0;
          otcTotal.settlementFee = 0;
          otcTotal.otcSettlement = 0;
        }
        const data = validSettlements.map((mid) => {
          return {
            id: mid.id,
            name: mid.name,
            method: mid.method,
            walletBalance: mid.payoutWalletBalance,
            pendingPayouts: mid.pendingPayouts,
            availableBalance: mid.availableBalance,
            balanceToSettle: mid.balanceToSettle,
            currency: formTotal.currency,
            date: mid.date,
            midId: mid.id,
            pspAccountId: mid.pspAccountId,
            clientId: savedData.merchant,
            propertyId: formTotal.propertyId,
            notes
          };
        });

        const requestData = {
          settlements: data,
          id: formTotal.settlementRequestId,
          amount: formTotal.requestedSettlement,
          propertyId: formTotal.propertyId,
          invoice: otcTotal.invoice,
          fxPair: otcTotal.fxPair,
          fxRate: otcTotal.fxRate,
          otcRequestedSettlement: otcTotal.otcRequestedSettlement,
          settlementFee: otcTotal.settlementFee,
          otcSettlement: otcTotal.otcSettlement,
          confirmationLink: otcTotal.confirmationLink
        };
        crudActions.post(`v1/otc/settlement/submit`, requestData)
          .then(() => {
            this.afterSuccessSave(formTotal.propertyId === "19" ? "Settlement cancelled." : "Settlement successfully initiated.");
          }).catch((err) => {
            this.errorUpdate(err ? err.message : '');
          });
      } else {
        this.errorUpdate('Please select a mid - even if you intend to cancel a settlement.');
      }
    }
  };

  onChangeFilter = () => {
    const { controls } = this.props;

    const isFormValid = controls.isFormValid();
    this.onChangeValidationUpdate(controls, isFormValid);

    if (isFormValid) {
      const { merchant, midIds, settlementId, updateSettlementDate } = controls;
      const url = `v1/otc/settlement/requested?clientId=${ merchant }&currency=${ controls.currency }&date=${ updateSettlementDate }&id=${settlementId}`;

      crudActions.get(url)
        .then((response) => {
          crudActions.get(`v1/data/input?clientId=${ merchant }&dataInputTypes=SETTLEMENT_BY_AMOUNT&midIds=${ midIds }&date=${ updateSettlementDate }&currency=${ controls.currency }`)
            .then((midsResponse) => {
              midsResponse = midsResponse.filter(row => row.availableBalance > 0 && row.collectedFunds > 0);
              if (midsResponse.length) {
                const newState = this.populateSettlementByRequestForm(midsResponse, response, controls);
                Object.assign(newState, {
                  showSecondPanel: true,
                  loadingDataInput: false,
                  lockButton: false,
                });
                this.updateState(newState);
              } else {
                this.errorUpdate("There is no available balance on the selected MIDs.");
              }
            }).catch((err) => {
              this.errorUpdate(err ? err.message : "");
            });
        })
        .catch((err) => {
          this.errorUpdate(err ? err.message : "");
        });
    }
  };

  populateSettlementByRequestForm = (responseMids, response, controls) => {
    const { otcSettlementByRequestBaseMidRowFields, otcSettlementByRequestBaseFields, otcSettlementFormByRequestTotal,
      otcSettlementFormByRequestOtc } = this.state;
    let OTC_SETTLEMENT_BY_REQUEST = [];
    const otcSettlementFormByRequest = [];
    const stateForUpdate = {};

    let availableBalance = 0;
    responseMids.forEach((midInfo) => {
      const midForm = this.getMidRowSettlementByRequestForm(midInfo);
      if (midForm.payoutWalletType !== "") {
        this.addPostValue(otcSettlementByRequestBaseMidRowFields.map(field => ({ ...field })), "payoutWalletBalance", midForm.payoutWalletType);
      }
      otcSettlementFormByRequest.push(midForm);
      OTC_SETTLEMENT_BY_REQUEST.push(otcSettlementByRequestBaseMidRowFields);
      availableBalance += parseFloat(midInfo.availableBalance);
    });

    const notesForm = new Form({
      notes: ""
    }, [{
      name: "notes",
      type: "isString",
      rules: {
        required: false,
      },
    }]);

    Object.assign(otcSettlementFormByRequestTotal, {
      availableBalance: parseFloat((availableBalance).toFixed(2)),
      balanceToSettle: 0,
      propertyId: "18",
      requestedSettlement: parseFloat(response.balanceToSettle).toFixed() || 0,
      currency: controls.currency || "",
      settlementRequestId: response.id
    });
    Object.assign(otcSettlementFormByRequestOtc, {
      invoice: response.invoice,
      fxPair: response.fxPair,
      fxRate: response.fxRate,
      otcRequestedSettlement: response.otcRequestedSettlement,
      settlementFee: response.settlementFee,
      settlementFeeValue: (response.settlementFee * 100 * response.fxRate) / response.balanceToSettle,
      otcSettlement: 0,
      confirmationLink: ""
    });
    Object.assign(stateForUpdate, {
      otcSettlementFormByRequestTotal: otcSettlementFormByRequestTotal,
      otcSettlementFormByRequestMids: [...otcSettlementFormByRequest],
      otcSettlementFormByRequestOtc: otcSettlementFormByRequestOtc,
      settlementMids: [...otcSettlementFormByRequest]
    });

    OTC_SETTLEMENT_BY_REQUEST.push([]);
    const baseFields = otcSettlementByRequestBaseFields.map(row => row.map(field => ({ ...field })));
    OTC_SETTLEMENT_BY_REQUEST = OTC_SETTLEMENT_BY_REQUEST.concat(baseFields);
    this.updateField(DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST, OTC_SETTLEMENT_BY_REQUEST);
    otcSettlementFormByRequest.push(new Form(), otcSettlementFormByRequestTotal, otcSettlementFormByRequestOtc, notesForm);
    Object.assign(stateForUpdate, {
      otcSettlementFormByRequest: otcSettlementFormByRequest
    });
    return stateForUpdate;
  };

  getMidRowSettlementByRequestForm = (midInfo) => {
    return new Form(
      {
        id: midInfo.id,
        name: `${ midInfo.name }` || '',
        provider: midInfo.providerName || '',
        account: midInfo.pspAccount,
        payoutWalletBalance: midInfo.walletBalance || 0,
        payoutWalletType: midInfo.payoutWalletType || "",
        pendingPayouts: midInfo.pendingPayouts || 0,
        availableBalance: midInfo.availableBalance ? parseFloat(midInfo.availableBalance) : 0,
        collectedFunds: midInfo.collectedFunds ? parseFloat(midInfo.collectedFunds) : 0,
        balanceToSettle: 0,
        date: midInfo.date || '',
        pspAccountId: midInfo.pspAccountId || '',
        disabled: false,
        isChecked: false
      },
      [
        {
          name: "id",
          type: "isNumber",
          rules: {
            min: 0,
            required: true,
          },
        },
        {
          name: "account",
          type: "isString",
          rules: {
            required: false,
          },
        },
        {
          name: "name",
          type: "isString",
          rules: {
            required: false,
          },
        },
        {
          name: "pendingPayouts",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "availableBalance",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "collectedFunds",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "payoutWalletBalance",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "payoutWalletType",
          type: "isString",
        },
        {
          name: "balanceToSettle",
          type: "isNumber",
          rules: {
            min: 0,
            required: true,
          },
        },
        {
          name: "provider",
          type: "isString",
          rules: {
            required: true,
          },
        }
      ]
    );
  };

  onDoubleClick = (index, fieldName, label) => {
    this.updateState({
      showPromptModal: true,
      title: `Update ${ label }`,
      changeValueMessage: `You are about to manually edit the ${ label }`,
      handleConfirmPromptModal: () => this.handleConfirmPromptModal(index, fieldName),
      handleClosePromptModal: () => this.handleClosePromptModal(index, fieldName),
    });
  };

  handleConfirmPromptModal = (index, fieldName) => {
    const { fields } = this.props;
    const field = fields[index].find(item => item.name === fieldName);
    field.disabled = !field.disabled;
    this.updateField(DATA_TYPES.OTC_SETTLEMENT_BY_REQUEST, fields);
    this.updateState({
      showPromptModal: false,
      title: "",
      changeValueMessage: "",
    });
  };

  handleClosePromptModal = () => {
    this.updateState({
      showPromptModal: false
    });
  };

  getOptionsFromState = (optionsName) => {
    return this.state[optionsName];
  };

  updateField = (name, value) => {
    this.props.updateField(name, value);
  };

  addPostValue = (fields, fieldName, value) => {
    fields.forEach(field => {
      if (field.name === fieldName) {field.postValue = (<span className={ `txValue-inputMask ${value === "N/A" ? 'full-width' : ''}` }>({value})</span>);}
    });
  };

  updateState = (stateForUpdate) => {
    this.props.updateState(stateForUpdate);
  };

  onChangeValidationUpdate = (controls, isFormValid) => {
    this.props.updateStateAfterOnChangeValidation(controls, isFormValid);
  };
  
  saveValidationUpdate = (form, isFormValid, allValid) => {
    this.props.updateStateAfterOnSaveValidation(form, isFormValid, allValid);
  };

  afterSuccessSave = (message) => {
    this.props.updateStateAfterSuccessSave(message);
  };

  errorUpdate = (message) => {
    this.props.showErrorAlert(message);
  };

  render() {
    return <></>;
  };
}

export default OtcSettlementByRequestComponent;